import type { RouteObject } from "react-router";

import { ErrorPage } from "@/components/Error/ErrorPage";
import { canAccessAccountNotificationSettings } from "@/components/PortfolioSidebar/permissions";
import { RequireAuth } from "@/components/Routing/RequireAuth";
import { RequireFeatureFlag } from "@/components/Routing/RequireFeatureFlag";

import { AccountNotificationSettingsPage } from "./pages/notification-settings/AccountNotificationSettingsPage";
import { accountRoutes } from "./routes";

export const accountRoute = [
  {
    path: accountRoutes.notificationSettings,
    element: (
      <RequireAuth permission={canAccessAccountNotificationSettings}>
        <RequireFeatureFlag flag="isMonthlyLivingExperienceReportEmailEnabled">
          <AccountNotificationSettingsPage />
        </RequireFeatureFlag>
      </RequireAuth>
    ),
  },
  {
    path: "*",
    element: <ErrorPage status={404} />,
  },
] satisfies RouteObject[];
